export default "__VITE_ASSET__RG0Cq_Pz__"